import { FormatEnum } from '@empathybroker/tsclient-stats/dist/enums/format.enum';
import { StatsQueriesTypes } from '@empathybroker/tsclient-stats/dist/enums/stats-queries-types';
import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { StatsResponse } from '@empathybroker/tsclient-stats/dist/models/stats-response';

import { ActionContext } from 'vuex';

import { FilterTypeEnum, QueriesTypeEnum } from '../../../enums';

import { ActionClass, AnalyticsState, ContextState, DateFilter, Filter, Pagination } from '../../../models';

import { CONTEXT_CONSTS } from '../../context/context.consts';
import { ANALYTICS_CONSTS } from '../analytics.consts';

export class LoadQueriesDataAction implements ActionClass {

  public static async execute({ dispatch, commit, state, rootGetters }: ActionContext<AnalyticsState, any>,
    payload: { type: QueriesTypeEnum; pagination: Pagination; download?: boolean }): Promise<StatsResponse> {
    let queriesData = state.data.queries[payload.type];
    const offset = ((payload.pagination.page - 1) * payload.pagination.itemsPerPage);
    if (payload.download || !queriesData ||
      ((queriesData.params.rows !== payload.pagination.itemsPerPage) || (queriesData.params.offset !== offset))) {
      try {
        queriesData = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: StatsReportsIdsEnum.TERM_SUCCESS,
          params: {
            type: {
              [QueriesTypeEnum.ALL]: StatsQueriesTypes.ALL_QUERIES,
              [QueriesTypeEnum.WITH_RESULTS]: StatsQueriesTypes.QUERIES_WITH_RESULTS,
              [QueriesTypeEnum.WITHOUT_RESULTS]: StatsQueriesTypes.QUERIES_WITHOUT_RESULTS
            }[payload.type],
            rows: payload.pagination.itemsPerPage,
            offset: offset,
            format: (payload.download ? FormatEnum.CSV : FormatEnum.JSON)
          }
        });
        if (!payload.download) {
          commit(ANALYTICS_CONSTS.mutations.setQueriesData, { data: queriesData, queriesType: payload.type });
        } else {
          const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
          const fileName = LoadQueriesDataAction.getDownloadFileName(payload.type, payload.pagination, context);
          LoadQueriesDataAction.downloadData(queriesData.data, fileName);
        }
      } catch (error) {
        throw error;
      }
    }
    return queriesData;
  }

  private static getDownloadFileName(type: QueriesTypeEnum, pagination: Pagination, context: ContextState): string {
    const typeString = {
      [QueriesTypeEnum.ALL]: 'all',
      [QueriesTypeEnum.WITH_RESULTS]: 'with-results',
      [QueriesTypeEnum.WITHOUT_RESULTS]: 'without-results'
    }[type];
    const dateFilter = (Object.values(context.filters)
      .find((filter: Filter) => (filter.config.type === FilterTypeEnum.DATE)) as DateFilter);
    const startDate = new Date(dateFilter.selectedValues[0]);
    const endDate = new Date(dateFilter.selectedValues[1]);
    endDate.setUTCDate(endDate.getUTCDate() - 1);
    const startDateString = `${startDate.getUTCFullYear()}-${(startDate.getUTCMonth() + 1)}-${startDate.getUTCDate()}`;
    const endDateString = `${endDate.getUTCFullYear()}-${(endDate.getUTCMonth() + 1)}-${endDate.getUTCDate()}`;
    return `queries-${typeString}_${pagination.itemsPerPage}_${startDateString}-${endDateString}`;
  }

  private static downloadData(data: any, fileName: string): void {
    const link = document.createElement('a');
    const blob = new Blob([data], { type: 'application/csv' });
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
